import { SelectOption } from '@/features/editMode/types/selectOption';
import { GetSuggestedPlacesListResponse } from '../types';

export const transformSuggestedPlacesListResponse = (
  suggestedPlacesList: GetSuggestedPlacesListResponse,
): SelectOption[] => {
  return suggestedPlacesList.suggestions
    ? suggestedPlacesList.suggestions.map((item) => ({
        label: item.placePrediction?.text.text ?? '',
        value: item.placePrediction?.placeId ?? '',
      }))
    : [];
};
